import React, {Component} from 'react';
import { Col, Row, FormGroup, Label, Input } from 'reactstrap';
import FormValidator from "../FormValidator";

const initialState = {
  salutation: '',
  title: '',
  firstname: '',
  lastname: '',
  companyName: '',
}

class UserFullName extends Component{
  constructor(props){
    super(props);

    this.valPerson = new FormValidator([
      {
        field: 'firstname',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie den Vornamen an.'
      },
      {
        field: 'lastname',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie den Nachnamen an.'
      }
    ]);
    this.valCompany = new FormValidator([
      {
        field: 'companyName',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie den Firmennamen an.'
      }
    ]);

    this.state = {
      ...initialState,
      ...props.state,
      validation: props.state.salutation === '03' ? this.valCompany.valid() : this.valPerson.valid()
    }

    const isVal = props.state.salutation === '03' ? this.valCompany.validate(this.state) : this.valPerson.validate(this.state);
    this.props.isValidForm(isVal.isValid, 'nameValidation');

    this.isCompany = props.state.salutation === '03';
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    if(event.target.name === 'salutation' && this.isCompany ? true : event.target.value === '03'){
      // switch between company and person mode
      if(event.target.value === '03' && event.target.name === 'salutation' ){
        this.setState({
          ...initialState,
          validation: this.valCompany.valid()
        })
        this.isCompany = true;
      } else {
        this.setState({
          ...initialState,
          validation: this.valPerson.valid()
        })
        this.isCompany = false;
      }
    }

    this.setState({
      [event.target.name]: event.target.value
    }, () => { // callback to send validation to upper instance after state was updatet
      const isVal = this.isCompany ? this.valCompany.validate(this.state) : this.valPerson.validate(this.state);
      this.props.isValidForm(isVal.isValid, 'nameValidation');
    });
    this.props.changeHandler(event);
  }

  render(){
    let choosenSalutation;
    if(this.isCompany){
      // validator will start alerting after first submission
      let validation = this.props.submitted ? this.valCompany.validate(this.state) : this.state.validation;
      choosenSalutation =
        <div>
        <Row>
          <Col md={3}>
            <FormGroup>
              <div>
                <Label for="salutation">Anrede*</Label>
                <Input type="select" value={this.state.salutation} name="salutation" id="salutation" onChange={this.handleChange.bind(this)}>
                  <option value="02" >Herr</option>
                  <option value="01" >Frau</option>
                  <option value="03" >Firma</option>
                </Input>
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <div className={validation.companyName.isInvalid ? 'has-error' : ''}>
                <Label for="companyName">Firma*</Label>
                <Input type="text" value={this.state.companyName} name="companyName" id="companyName" onChange={this.handleChange.bind(this)}/>
                <span className="help-block">{validation.companyName.message}</span>
              </div>
            </FormGroup>
          </Col>
        </Row>
        </div>;
    } else {
      // validator will start alerting after first submission
      let validation = this.props.submitted ? this.valPerson.validate(this.state) : this.state.validation;
      choosenSalutation =
        <div>
        <Row>
          <Col md={3}>
            <FormGroup>
              <div>
                <Label for="salutation">Anrede*</Label>
                <Input type="select" value={this.state.salutation} name="salutation" id="salutation" onChange={this.handleChange.bind(this)}>
                  <option value="02" >Herr</option>
                  <option value="01" >Frau</option>
                  <option value="03" >Firma</option>
                </Input>
              </div>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <div>
                <Label for="title">Titel</Label>
                <Input type="select" value={this.state.title} name="title" id="title" onChange={this.handleChange.bind(this)}>
                  <option value="" ></option>
                  <option value="02" >Prof.</option>
                  <option value="01" >Dr.</option>
                  <option value="03" >Prof. Dr.</option>
                </Input>
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <div className={validation.firstname.isInvalid ? 'has-error' : ''}>
                <Label for="firstname">Vorname*</Label>
                <Input type="text" value={this.state.firstname} name="firstname" id="firstname" onChange={this.handleChange.bind(this)}/>
                <span className="help-block">{validation.firstname.message}</span>
              </div>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
            <div className={validation.lastname.isInvalid ? 'has-error' : ''}>
              <Label for="lastname">Nachname*</Label>
              <Input type="text" value={this.state.lastname} name="lastname" id="lastname" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.lastname.message}</span>
            </div>
            </FormGroup>
          </Col>
        </Row>
        </div>;
    }

    return (
      <div>
        {choosenSalutation}
      </div>
    );
  }
}

export default UserFullName;


// WEBPACK FOOTER //
// ./src/components/FormGroups/UserFullName.js